// The reports the project page renders: generated with il-report from the
// layouts in plans/usage-demo-reports and bundled as strings by
// scripts/build-usage-demo-reports.py. A usage revision past the generated
// ones (a session's "Refresh usage data") shows the refreshed variant.

import type { UsageAnalysisRevision } from "../model/types";
import { PLAYBOOK_V1, SNAPSHOT_SNOWFLAKE_V1, SNAPSHOT_V1, USAGE_V1, USAGE_V2, USAGE_V3 } from "./generated";

/** Snapshots written for a project other than Microsoft's. */
const SNAPSHOTS: Record<string, string> = { "usage-snowflake": SNAPSHOT_SNOWFLAKE_V1 };

export const reportHtml = (analysis: UsageAnalysisRevision, projectId: string): string | undefined => {
    if (analysis.kind === "snapshot") return SNAPSHOTS[projectId] ?? SNAPSHOT_V1;
    if (analysis.kind === "playbook") return PLAYBOOK_V1;
    if (analysis.revision <= 1) return USAGE_V1;
    if (analysis.revision === 2) return USAGE_V2;
    return USAGE_V3;
};
